module.exports = __webpack_public_path__ + "static/media/butterfly.38c7a8c5.png";